import { render, staticRenderFns } from "./CompanyTransferCreateModal.vue?vue&type=template&id=44a80348&scoped=true&"
import script from "./CompanyTransferCreateModal.vue?vue&type=script&lang=js&"
export * from "./CompanyTransferCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTransferCreateModal.vue?vue&type=style&index=0&id=44a80348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a80348",
  null
  
)

export default component.exports